export enum VoyFleetAlarmCustomEvents {
    HandleAlarm = "handle-alarm",
}

export enum AlarmMarkupTitles {
    ArrETA = 'Arr. GSIS',
    PlannedSpeed = 'Planned speed'
}